import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { initialState } from "./initial";
import { setGenericError, setLoading, setMfa, setPxCaptchaType, emailBlur } from "./sharedActions";
import { isValidEmail, validatePassword } from "../utils/passwordValidations";
import { gdprCountries, getCurrentView, isCredentialsValid } from "./helpers";
import * as AuthService from "../lib/authService";
import { initialCredentials, initialSso, View } from "./types";
import { sdkLogin, sdkLoginReducers } from "./reducers/sdkLogin";
import { sdkSignup, sdkSignupReducers } from "./reducers/sdkSignup";
import { sdkSsoLogin, sdkSsoLoginReducers } from "./reducers/sdkSsoLogin";
import { sdkResetPassword, sdkResetPasswordReducers } from "./reducers/sdkResetPassword";
import { getTexts } from "../lib/contentful/defaultTexts";
import { sdkValidateEmailAddress, sdkValidateEmailAddressReducers } from "./reducers/sdkValidateEmailAddress";
export var fetchCountry = createAsyncThunk('oneauth/fetchCountry', /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_, _ref) {
    var getState, rejectWithValue;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          getState = _ref.getState, rejectWithValue = _ref.rejectWithValue;
          _context.prev = 1;
          _context.next = 4;
          return AuthService.fetchCountry();
        case 4:
          return _context.abrupt("return", _context.sent);
        case 7:
          _context.prev = 7;
          _context.t0 = _context["catch"](1);
          return _context.abrupt("return", rejectWithValue(_context.t0));
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 7]]);
  }));
  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
/**
 * The Silce
 */
export var oneAuthSlice = createSlice({
  name: 'oneauth',
  initialState: initialState,
  reducers: {
    reset: function reset() {
      return initialState;
    },
    resetViews: function resetViews(state, action) {
      var view = action.payload.view;
      state.frontView = view;
      state.backView = view === View.SIGNUP ? View.SIGNIN : View.SIGNUP;
      state.showBack = false;
    },
    setEnv: function setEnv(state, action) {
      state.env = action.payload.env;
    },
    setClientId: function setClientId(state, action) {
      state.clientId = action.payload.clientId;
    },
    flipView: function flipView(state, action) {
      var view = action.payload.view;
      state.frontView = state.showBack && view || state.frontView;
      state.backView = !state.showBack && view || state.backView;
      state.showBack = !state.showBack;
      state.resetPassword.successScreen = false;
    },
    setEmail: function setEmail(state, action) {
      var signinEmail = state.signin.credentials.email,
        signupEmail = state.signup.credentials.email,
        resetPasswordEmail = state.resetPassword.credentials.email;
      var valid = isValidEmail(action.payload.email);
      [signupEmail, signinEmail, resetPasswordEmail].forEach(function (obj) {
        obj.valueChanged = obj.value !== action.payload.email;
        obj.value = action.payload.email;
        obj.valid = valid;
        obj.changed = true;
        obj.touched = true;
        obj.error = '';
      });
      state.signup.showUserInfo = state.signup.showUserInfo || isCredentialsValid(state.signup);
    },
    emailFocus: function emailFocus(state) {
      var view = getCurrentView(state);
      if (!view) return;
      state[view].credentials.email.touched = true;
      state[view].credentials.email.focus = true;
      if (state[view].credentials.email.valueChanged) {
        state[view].credentials.email.valueChanged = false;
      }
    },
    setEmailError: function setEmailError(state, action) {
      var view = getCurrentView(state);
      if (!view) return;
      state[view].credentials.email.valid = false;
      state[view].credentials.email.error = action.payload.error;
    },
    passwordFocus: function passwordFocus(state) {
      var view = getCurrentView(state);
      if ([View.SIGNIN, View.SIGNUP].indexOf(view) == -1) {
        return;
      }
      state[view].credentials.password.touched = true;
      state[view].credentials.password.focus = true;
      if (state[view].credentials.password.valueChanged) {
        state[view].credentials.password.valueChanged = false;
      }
    },
    passwordBlur: function passwordBlur(state) {
      var view = getCurrentView(state);
      if ([View.SIGNIN, View.SIGNUP].indexOf(view) == -1) {
        return;
      }
      state[view].credentials.password.focus = false;
      if (state[view].credentials.password.valueChanged) {
        state[view].credentials.password.valueChanged = false;
      }
    },
    setPassword: function setPassword(state, action) {
      var _action$payload = action.payload,
        password = _action$payload.password,
        onView = _action$payload.onView;
      var view = onView || getCurrentView(state);
      if ([View.SIGNIN, View.SIGNUP].indexOf(view) == -1) {
        return;
      }
      state[view].credentials.password.valueChanged = state[view].credentials.password.value != password;
      state[view].credentials.password.value = password;
      state[view].credentials.password.valid = validatePassword(password);
      state[view].credentials.password.changed = true;
      if (view === View.SIGNUP) {
        state.signup.showUserInfo = state.signup.showUserInfo || isCredentialsValid(state.signup);
      }
    },
    setMfaError: function setMfaError(state) {
      state.signup.credentials.error = getTexts().resetPassword.genericError;
      return;
    },
    selectUserType: function selectUserType(state, action) {
      state.signup.userInfo.userType = action.payload.userType;
      state.signup.userInfo.selectedUserTypeIndex = action.payload.index;
    },
    selectStudentType: function selectStudentType(state, action) {
      state.signup.userInfo.student.studentType = action.payload.studentType;
      state.signup.userInfo.student.selectedIndex = action.payload.index;
    },
    selectGradYear: function selectGradYear(state, action) {
      var student = state.signup.userInfo.student;
      student.highschool.selectedIndex = action.payload.index;
      student.highschool.hsGradYear = +student.highschool.years[action.payload.index].text;
    },
    selectCollege: function selectCollege(state, action) {
      var student = state.signup.userInfo.student;
      student.college.campusId = action.payload.campusId;
      student.college.name = action.payload.name;
      student.college.isCollegeSelected = true;
    },
    clearCollege: function clearCollege(state) {
      var student = state.signup.userInfo.student;
      student.college.campusId = '';
      student.college.name = '';
      student.college.isCollegeSelected = false;
      student.college.selectedIndex = undefined;
      student.college.yearInCollege = 0;
    },
    selectCollegeYear: function selectCollegeYear(state, action) {
      var student = state.signup.userInfo.student;
      student.college.selectedIndex = action.payload.index;
      student.college.yearInCollege = action.payload.index + 1;
    },
    setCountry: function setCountry(state, action) {
      state.country = action.payload.country;
      state.isGdpr = !!gdprCountries[action.payload.country];
    },
    setTermsAndPromos: function setTermsAndPromos(state, action) {
      state.signup.gdpr = action.payload;
    },
    setLocale: function setLocale(state, action) {
      state.locale = action.payload.locale;
    },
    removeSsoCredentials: function removeSsoCredentials(state) {
      state.signup.showUserInfo = false;
      state.signup.isSso = false;
      state.sso = initialSso;
      state.signup.credentials = initialCredentials;
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(sdkLogin.pending, sdkLoginReducers.pending).addCase(sdkLogin.rejected, sdkLoginReducers.rejected).addCase(sdkLogin.fulfilled, sdkLoginReducers.fulfilled);
    builder.addCase(sdkSsoLogin.pending, sdkSsoLoginReducers.pending).addCase(sdkSsoLogin.rejected, sdkLoginReducers.rejected).addCase(sdkSsoLogin.fulfilled, sdkLoginReducers.fulfilled);
    builder.addCase(sdkSignup.pending, sdkSignupReducers.pending).addCase(sdkSignup.rejected, sdkSignupReducers.rejected).addCase(sdkSignup.fulfilled, sdkSignupReducers.fulfilled);
    builder.addCase(sdkResetPassword.pending, sdkResetPasswordReducers.pending).addCase(sdkResetPassword.rejected, sdkResetPasswordReducers.rejected).addCase(sdkResetPassword.fulfilled, sdkResetPasswordReducers.fulfilled);
    builder.addCase(sdkValidateEmailAddress.rejected, sdkValidateEmailAddressReducers.rejected).addCase(sdkValidateEmailAddress.fulfilled, sdkValidateEmailAddressReducers.fulfilled);
    builder.addCase(setMfa, function (state, action) {
      state.mfa = _objectSpread(_objectSpread({}, state.mfa), action.payload);
    }).addCase(setGenericError, function (state, action) {
      var view = action.payload.onView || getCurrentView(state);
      if (!view) return;
      state[view].credentials.error = action.payload.error;
    }).addCase(emailBlur, function (state) {
      var view = getCurrentView(state);
      if (!view) return;
      state[view].credentials.email.focus = false;
      if (state[view].credentials.email.valueChanged) {
        state[view].credentials.email.valueChanged = false;
      }
    }).addCase(setLoading, function (state, action) {
      var view = action.payload.onView || getCurrentView(state);
      if (!view) return;
      state[view].loading = action.payload.loading;
    }).addCase(setPxCaptchaType, function (state, action) {
      state.pxCaptchaType = action.payload.type;
    })
    // fetch country
    .addCase(fetchCountry.fulfilled, function (state, action) {
      var _action$payload$data$;
      /* istanbul ignore next */
      var country = ((_action$payload$data$ = action.payload.data.geolocation) === null || _action$payload$data$ === void 0 ? void 0 : _action$payload$data$.countryCode) || 'US';
      state.country = country;
      state.isGdpr = !!gdprCountries[country];
    }).addCase(fetchCountry.rejected, function (state) {
      state.country = 'US';
      state.isGdpr = false;
    });
  }
});

/**
 * Actions
 */
var _oneAuthSlice$actions = oneAuthSlice.actions,
  reset = _oneAuthSlice$actions.reset,
  setEnv = _oneAuthSlice$actions.setEnv,
  setEmail = _oneAuthSlice$actions.setEmail,
  flipView = _oneAuthSlice$actions.flipView,
  setLocale = _oneAuthSlice$actions.setLocale,
  setCountry = _oneAuthSlice$actions.setCountry,
  resetViews = _oneAuthSlice$actions.resetViews,
  emailFocus = _oneAuthSlice$actions.emailFocus,
  setClientId = _oneAuthSlice$actions.setClientId,
  setPassword = _oneAuthSlice$actions.setPassword,
  setMfaError = _oneAuthSlice$actions.setMfaError,
  clearCollege = _oneAuthSlice$actions.clearCollege,
  passwordFocus = _oneAuthSlice$actions.passwordFocus,
  selectCollege = _oneAuthSlice$actions.selectCollege,
  setEmailError = _oneAuthSlice$actions.setEmailError,
  selectUserType = _oneAuthSlice$actions.selectUserType,
  selectGradYear = _oneAuthSlice$actions.selectGradYear,
  selectStudentType = _oneAuthSlice$actions.selectStudentType,
  selectCollegeYear = _oneAuthSlice$actions.selectCollegeYear,
  setTermsAndPromos = _oneAuthSlice$actions.setTermsAndPromos,
  removeSsoCredentials = _oneAuthSlice$actions.removeSsoCredentials,
  passwordBlur = _oneAuthSlice$actions.passwordBlur;
export { reset, setEnv, setEmail, flipView, setLocale, setCountry, resetViews, emailFocus, setClientId, setPassword, setMfaError, clearCollege, passwordFocus, selectCollege, setEmailError, selectUserType, selectGradYear, selectStudentType, selectCollegeYear, setTermsAndPromos, removeSsoCredentials, passwordBlur };
export default oneAuthSlice.reducer;